// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2TutPUX5Jti3IaRQBdiyr4{min-width:65px}._2TutPUX5Jti3IaRQBdiyr4>div{padding:0 5px}._2TutPUX5Jti3IaRQBdiyr4 h6{color:var(--grayText);font-size:10px}._2TutPUX5Jti3IaRQBdiyr4 span{font-size:15px}._2eoUTBiyqTC4J-EGrbdd5F{background:var(--inputBorderColor);height:20px;margin-left:50px;margin-right:10px;width:1px}._1Oz70J1B2Afoy1-V3JBi-J{flex:1;position:relative;width:100%}._3OepZlNEzvbHH8myn3O8Rr{padding:10px 3rem;height:100%;flex:1;margin-top:10px;box-sizing:border-box}._2NZeZRwHlmfv1EtaWPxsMS{background:var(--greyBackgroundColor);border-radius:50px;padding:10px 15px}._1R0gk32Q-OHRI9AUYGPtfP{display:flex;justify-content:center;align-items:flex-start;height:100%}._3L1qzenFuw5wIzJ7-Gbyp5{width:400px;height:100%;padding-left:30px;padding-bottom:20px;box-sizing:border-box;display:flex;position:relative}._363jEhIVBjNm25k1YsL2ME{width:400px;max-height:100%;height:fit-content}._3t9WnLWtp1oA1SCg2w0y8T{margin:0px 20px 0px 20px !important}._363jEhIVBjNm25k1YsL2ME::-webkit-scrollbar{display:none}._363jEhIVBjNm25k1YsL2ME{-ms-overflow-style:none;scrollbar-width:none}._3DBIzd4Y6vCFmQP26NA13m{width:1050px;margin-right:400px}._2-YzUFFvG26AAte5Yy-nUH{width:400px;margin-left:1050px;z-index:100;padding:24px;box-sizing:border-box;position:fixed}._2um8Uf-8rasDJrGWN4bGWu{display:flex;flex-direction:column;width:400px;max-height:calc(100vh - 160px);overflow:auto;align-content:center}._3c_ozLa4UWzHsjqyGDXOBt{height:500px;width:100%;justify-content:center;align-items:center;margin-bottom:2rem;border-radius:5px}._276MyPAfU8Wo8b9sPlZvVf{flex:1;width:100%;box-sizing:border-box;padding:0 15px}._276MyPAfU8Wo8b9sPlZvVf::-webkit-scrollbar{display:none}._276MyPAfU8Wo8b9sPlZvVf{-ms-overflow-style:none;scrollbar-width:none}._393I0pbvJyVGh067jOSpuB{font-size:20px !important;font-weight:700 !important;margin:25px 0px 0px 0px !important}._32qzcT3n57Ioxdu9fwwAsE{align-self:center;padding:8px 16px !important;cursor:pointer !important;margin:8px !important;font-size:15px !important}._32qzcT3n57Ioxdu9fwwAsE :hover{text-decoration:none !important}._32qzcT3n57Ioxdu9fwwAsE:hover{text-decoration:none !important}", ""]);
// Exports
exports.locals = {
	"mainBackgroundColor": "#fff",
	"cardBackgroundColor": "#fff",
	"cardSecondaryBackgroundColor": "#fff",
	"blurredBackgroundColor": "rgba(255,255,255,.9176470588)",
	"fadedTextColor": "#596269",
	"blurredAdornmentColor": "#a9a9a9",
	"focusedAdornmentColor": "#000",
	"primaryItemColor": "#346094",
	"primaryItemBackdropColor": "rgba(50,103,168,.24)",
	"primaryItemLightColor": "rgba(52,95,148,.1921568627)",
	"dividerColor": "#f5f5f5",
	"generalTextColor": "#000",
	"areaChartNegativeColor": "#f7e0e3",
	"areaChartPositiveColor": "#e0f6e6",
	"secondaryButtonBackgroundColor": "#f7fafc",
	"secondaryButtonBackgroundHoverColor": "#d2e3ee",
	"colorOverlay": "rgba(255,255,255,.7)",
	"greyBackgroundColor": "#f8f8f8",
	"inputBorderColor": "rgba(0,0,0,.15)",
	"inputBorderActiveColor": "rgba(213,213,213,.438)",
	"disabledButtonText": "#fff",
	"scrollbarColor": "#e9e9e9",
	"segmentedControlBackgroundColor": "#f0f7ff",
	"segmentedControlActiveColor": "#336094",
	"positiveValueColor": "#02b334",
	"positiveValueLighterColor": "rgba(2,179,52,.16)",
	"negativeValueColor": "#b2292e",
	"negativeValueLighterColor": "rgba(178,41,46,.16)",
	"futuresColor": "#28bbd6",
	"fplGreen": "\"#13B53F\"",
	"futuresBackdropColor": "rgba(40,188,214,.2196078431)",
	"stickyCard": "#ffc",
	"selectListItemColor": "rgba(51,96,148,.1)",
	"selectListSelectedItemColor": "#346094",
	"bar-cell": "_2TutPUX5Jti3IaRQBdiyr4",
	"bar-cell-pipe": "_2eoUTBiyqTC4J-EGrbdd5F",
	"pageWrapper": "_1Oz70J1B2Afoy1-V3JBi-J",
	"mainContentWrapper": "_3OepZlNEzvbHH8myn3O8Rr",
	"streamingVolumeWrapper": "_2NZeZRwHlmfv1EtaWPxsMS",
	"content": "_1R0gk32Q-OHRI9AUYGPtfP",
	"watchlistWrapper": "_3L1qzenFuw5wIzJ7-Gbyp5",
	"watchlistCard": "_363jEhIVBjNm25k1YsL2ME",
	"buying-placebolder": "_3t9WnLWtp1oA1SCg2w0y8T",
	"wrapper": "_3DBIzd4Y6vCFmQP26NA13m",
	"securityScreenTradingTicketWrapper": "_2-YzUFFvG26AAte5Yy-nUH",
	"tradingTicketGroupWrapper": "_2um8Uf-8rasDJrGWN4bGWu",
	"chartWrapper": "_3c_ozLa4UWzHsjqyGDXOBt",
	"scrollWrapper": "_276MyPAfU8Wo8b9sPlZvVf",
	"ratingsHeader": "_393I0pbvJyVGh067jOSpuB",
	"tradeOptionsLink": "_32qzcT3n57Ioxdu9fwwAsE"
};
module.exports = exports;
